import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveTab } from '../../store/opinionsTabSlice.js';
import { tabsConfigU, emptyU } from './about_users/opinionsTableConfigAboutUsers.js';
import { tabsConfigT, emptyT } from './about_trainings/opinionsTableConfigAboutTrainings.js';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import LineWithButtons from '../../components/components/line_with_buttons/lineWithButtons.jsx';
import OpinionsT from './about_trainings/opinionsT.jsx';
import OpinionsU from './about_users/opinionsU.jsx';

import './Opinions.css';

function Opinions() {

  const dispatch = useDispatch(); 
  const activeTab = useSelector((state) => state.opinions.activeTab);

  return (
    <div>
      <Menu />
      <Content>
        {activeTab === 'Opinie o użytkownikach' && <LineWithButtons tabs={tabsConfigU(activeTab, dispatch, setActiveTab)} buttons={emptyU} />}
        {activeTab === 'Opinie o treningach' && <LineWithButtons tabs={tabsConfigT(activeTab, dispatch, setActiveTab)} buttons={emptyT} />}

        {activeTab === 'Opinie o użytkownikach' && <OpinionsU />}
        {activeTab === 'Opinie o treningach' && <OpinionsT /> }
      </Content>
    </div>
  );
}

export default Opinions;